import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export type CibleRecomptage = 'TROUPEAU' | 'PISCICULTURE';
export type MotifRecomptage = 'MORTS_NON_DECLARES' | 'NAISSANCES' | 'VENTE_SORTIE' | 'VOL_PERTE' | 'ERREUR_COMPTAGE' | 'AUTRE';

/** Motifs d'écart : sens accepté (hausse = plus de têtes que prévu), comme le serveur */
export const MOTIFS_RECOMPTAGE: { code: MotifRecomptage; libelle: string; hausse: boolean; baisse: boolean; troupeauSeulement?: boolean }[] = [
  { code: 'MORTS_NON_DECLARES', libelle: 'Morts non déclarés', hausse: false, baisse: true },
  { code: 'NAISSANCES', libelle: 'Naissances', hausse: true, baisse: false, troupeauSeulement: true },
  { code: 'VENTE_SORTIE', libelle: 'Vente ou sortie', hausse: false, baisse: true },
  { code: 'VOL_PERTE', libelle: 'Vol ou perte', hausse: false, baisse: true },
  { code: 'ERREUR_COMPTAGE', libelle: 'Erreur de comptage', hausse: true, baisse: true },
  { code: 'AUTRE', libelle: 'Autre (préciser)', hausse: true, baisse: true },
];

export interface Recomptage {
  id?: number;
  clientRef?: string;
  fermeId?: number;
  compte: number;
  attendu: number;
  motif?: MotifRecomptage | null;
  note?: string;
  date: string;
  ecart?: number;
  resume?: string;
  createdBy?: string;
  createdAt?: string;
}

/** Recomptage d'un troupeau ou d'un lot de poissons : nombre réel, écart et motif (mouvement tracé) */
@Injectable({ providedIn: 'root' })
export class RecomptageService {

  constructor(private http: HttpClient) {}

  private base(cible: CibleRecomptage, id: number): string {
    return `${environment.BASE_URL}/api/${cible === 'TROUPEAU' ? 'troupeaux' : 'pisciculture'}/${id}`;
  }

  recompter(cible: CibleRecomptage, id: number, r: Recomptage): Observable<Recomptage> {
    return this.http.post<Recomptage>(`${this.base(cible, id)}/recomptage`, r);
  }

  historique(cible: CibleRecomptage, id: number): Observable<Recomptage[]> {
    return this.http.get<Recomptage[]>(`${this.base(cible, id)}/recomptages`);
  }
}
